export const TenantStatusList = ["active", "inactive", "suspended"] as const;
export const TenantThingTypeMrn = "mrn:sl2:::tenant";
